export default {
  All: 'all',
  Active: 'active',
  Inactive: 'inactive',
}
